import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import { EmptyState } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";
import MasterySet from './MasterySet';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));
let mounted = false;

const LessonMasteries = props => {
  const { className, reload, ...rest } = props;
  const model = useSelector(state => state.models.lesson);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    if (mounted) setOpenEdit(true);
  };

  const handleEditClose = () => {
    if (mounted) setOpenEdit(false);
  };

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Lesson Masteries" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            {model.mastery_levels.map((mastery, index) => (
              <TableRow key={index}>
                <TableCell className={classes.header}>
                  {mastery.name_en}{mastery.name_zh ? " " + mastery.name_zh : ""}
                  <div><Typography variant="caption">{mastery.code}</Typography></div>
                </TableCell>
                <TableCell align="right">
                  <Button color="primary" component={RouterLink} size="small" to={`/masteries/${mastery.id}/summary`} variant="outlined">
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <EmptyState active={!model.mastery_levels.length} message="No masteries assigned." />
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <MasterySet onClose={handleEditClose} reload={reload} open={openEdit} model={model} />
    </Card>
  );
};

LessonMasteries.propTypes = {
  className: PropTypes.string,
};

export default LessonMasteries;
